<div class="btn-group" style="min-width: 150px;">
  <button type="button" style="min-width: 70px;" class="btn btn-outline-secondary" [disabled]="disable" [class.active]="Settings.value() === true" (click)="Settings.value(true)" name="customChoiceTrue">
    <i *ngIf="Settings.value() === true" class="fa fa-check"></i><span>{{ Settings.choiceTrue || 'Yes' }}</span>
  </button>
  <button type="button" style="min-width: 70px;" class="btn btn-outline-secondary" [disabled]="disable" [class.active]="Settings.value() === false" (click)="Settings.value(false)" name="customChoiceFalse">
      <i *ngIf="Settings.value() === false" class="fa fa-check"></i><span>{{ Settings.choiceFalse || 'No' }}</span>
  </button>
</div>
